import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Link as ReactRouterLink, NavLink as ReactRouterNavLink } from 'react-router-dom'
import isEmail from 'validator/lib/isEmail'

export default function LinkBase({ children, className, nav, to, ...others }: props) {
  const componentClassNames = classNames('LinkBase', className)
  const toIsEmail = isEmail(to)

  if (toIsEmail || to.includes('http')) {
    let body = children
    let href = to

    if (toIsEmail) {
      body = children || to
      href = `mailto:${to}`
    }

    return (
      <a {...others} href={href} target="_blank" className={componentClassNames}>
        {body}
      </a>
    )
  }

  const Component = nav ? ReactRouterNavLink : ReactRouterLink

  return (
    <Component {...others} to={to} className={componentClassNames}>
      {children}
    </Component>
  )
}

LinkBase.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  nav: PropTypes.bool,
  to: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/LinkBase/LinkBase.js